export const scrollToReviewsTab = () => {
  const hotelInfoElement = document.getElementById("hotel-info");
  if (hotelInfoElement) {
    hotelInfoElement.scrollIntoView({ behavior: "smooth" });
    window.dispatchEvent(
      new CustomEvent("selectHotelInfoTab", { detail: "reviews" })
    );
  }
};

export const openReviewsDialog = () => {
  window.dispatchEvent(
    new CustomEvent("selectHotelInfoTab", { detail: "reviews" })
  );
};
